export var PhotoCapture;
(function (PhotoCapture) {
    PhotoCapture["PHOTO_CAPTURE"] = "PHOTO_CAPTURE";
    PhotoCapture["SCRIPT_DEFAULT"] = "DEFAULT";
    PhotoCapture["SCRIPT_TERMINATE"] = "TERMINATE";
    PhotoCapture["SCRIPT_ACKNOWLEDGEMENT"] = "ACKNOWLEDGEMENT";
    PhotoCapture["SUCCESS"] = "SUCCESS";
    PhotoCapture["MILEAGE_CAPTURE"] = "MILEAGE_CAPTURE";
    PhotoCapture["LICENSE_PLATE_CAPTURE"] = "LICENSE_PLATE_CAPTURE";
    PhotoCapture["VIN_CAPTURE"] = "VIN_CAPTURE";
    PhotoCapture["GUIDED_PHOTO_CAPTURE"] = "GUIDED_PHOTO_CAPTURE";
})(PhotoCapture || (PhotoCapture = {}));
//# sourceMappingURL=PhotoCapture.js.map